import { Link } from "react-router-dom";
import JttgDigitalCredit from "./JttgDigitalCredit";
import { NAV_LINKS } from "./SiteHeader";
import { EDUCATION_HUBS } from "@/data/educationHubs";

const trailerTypes = [
  { label: "Dump Trailers", href: "/dump-trailers" },
  { label: "Flatbed Trailers", href: "/flatbed-trailers" },
  { label: "Roll-Off Trailers", href: "/roll-off-trailers" },
  { label: "Car Haulers", href: "/car-haulers" },
  { label: "Lowboy / Equipment", href: "/lowboy-trailers" },
  { label: "Tilt Trailers", href: "/tilt-trailers" },
  { label: "Payload Calculator", href: "/trailer-payload-calculator" },
  { label: "Podcast", href: "/podcast" },
];

const linkCls = "text-[16px] leading-[1.7] text-white/90 no-underline transition-colors hover:text-white";

const SiteFooter = () => (
  <footer className="bg-[#111111] px-6 pb-10 pt-[60px] text-white md:px-10">
    <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-[30px] border-b border-white/[0.12] pb-[30px] md:grid-cols-[1.3fr_1fr_1fr_1fr] md:gap-[40px]">
      <div>
        <Link to="/" className="mb-4 block font-display text-[28px] font-bold uppercase tracking-[0.5px] text-white no-underline">
          Juan <span className="text-primary">The</span> Trailer Guy
        </Link>
        <p className="text-[16px] leading-[1.7] text-white/90">
          Independent trailer education: towing requirements, weight ratings, maintenance and practical industry insight from real experience.
        </p>
      </div>
      <nav aria-label="Footer main">
        <h4 className="mb-4 font-display text-base font-bold uppercase tracking-[0.5px]">Explore</h4>
        <div className="flex flex-col gap-2">
          {NAV_LINKS.map((l) => <Link key={l.href} to={l.href} className={linkCls}>{l.label}</Link>)}
          <Link to="/contact" className={linkCls}>Contact</Link>
        </div>
      </nav>
      <nav aria-label="Guide topics">
        <h4 className="mb-4 font-display text-base font-bold uppercase tracking-[0.5px]">Guide Topics</h4>
        <div className="flex flex-col gap-2">
          {EDUCATION_HUBS.map((h) => <Link key={h.slug} to={h.path} className={linkCls}>{h.title}</Link>)}
        </div>
      </nav>
      <nav aria-label="Trailer types">
        <h4 className="mb-4 font-display text-base font-bold uppercase tracking-[0.5px]">Trailer Types</h4>
        <div className="flex flex-col gap-2">
          {trailerTypes.map((l) => <Link key={l.href} to={l.href} className={linkCls}>{l.label}</Link>)}
        </div>
      </nav>
    </div>

    <div className="mx-auto mt-6 flex max-w-[1200px] flex-col items-center gap-2 text-xs text-white/85">
      <Link to="/privacy-policy" className="text-white/85 no-underline hover:text-white">Privacy Policy &amp; Legal Terms</Link>
      <p className="mx-auto mt-2 max-w-3xl text-center text-[11px] italic leading-5 text-white/75">
        Juan The Trailer Guy is an independent educational resource. We do not sell trailers, take orders, arrange financing, or represent any manufacturer or dealership.
        Content is general information only. Always confirm ratings and requirements with the manufacturer and your local authorities.
      </p>
      <p>© {new Date().getFullYear()} Juan The Trailer Guy · Juan Hernandez. All rights reserved.</p>
    </div>
    <JttgDigitalCredit />
  </footer>
);

export default SiteFooter;
